import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import ArchiveIcon from "@mui/icons-material/Archive";
import React from "react";
import { ArchiveApplicationModalController, ArchiveApplicationModalControllerDelegate } from "./controller";

/** A ação é destrutiva: o ícone do título troca o azul do tema pelo vermelho. */
const destructiveTitleSx = {
  "& svg": {
    color: "error.main",
    backgroundColor: (theme: any) => alpha(theme.palette.error.light, 0.35),
  },
};

interface State {
  isLoading: boolean;
  errorMessage: string;
}

interface Props {
  applicationId: number;
  delegate: ArchiveApplicationModalDelegate;
}

export interface ArchiveApplicationModalDelegate {
  shouldCloseModal: () => void;
  applicationShouldLogout: () => void;
  didArchiveApplication: () => void;
}

class ArchiveApplicationModal extends React.Component<Props, State> implements ArchiveApplicationModalControllerDelegate {

  controller: ArchiveApplicationModalController

  constructor(props: Props) {
    super(props);
    this.state = {
      isLoading: false,
      errorMessage: "",
    }
    this.controller = new ArchiveApplicationModalController(this);
  }

  // delegate
  didArchiveApplication(){
    this.props.delegate.didArchiveApplication();
  }

  didFailArchiveApplication(message: string) {
    this.setState({ isLoading: false, errorMessage: message });
  };

  applicationShouldLogout() {
    this.props.delegate.applicationShouldLogout();
  };

  // internals
  didClickDelete() {
    this.setState({ isLoading: true, errorMessage: "" });
    const token = localStorage.getItem("AccessToken")!;
    this.controller.archiveApplication(token, this.props.applicationId)
  }

  didClickClose() {
    if (this.state.isLoading) {
      return;
    }
    this.props.delegate.shouldCloseModal();
  }

  renderLoading() {
    return (
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        gap={2}
        paddingY={5}
      >
        <CircularProgress color="error" />
        <Typography variant="body2" color="text.secondary">
          Arquivando aplicação...
        </Typography>
      </Box>
    );
  }

  renderForm() {
    return (
      <Box display="flex" flexDirection="column" sx={{ gap: 2 }}>
        {this.state.errorMessage && (
          <Alert
            severity="error"
            onClose={() => this.setState({ errorMessage: "" })}
          >
            {this.state.errorMessage}
          </Alert>
        )}

        <Typography color="text.secondary">
          Tem certeza que deseja arquivar esta aplicação?
        </Typography>

        <Alert severity="warning">
          Você apenas poderá restaurá-la entrando em contato com a
          administração.
        </Alert>
      </Box>
    );
  }

  // Internals
  render() {
    return (
      <Dialog
        open
        onClose={() => this.didClickClose()}
        variant="modal"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle variant="modal" sx={destructiveTitleSx}>
          <ArchiveIcon />
          Arquivar aplicação
        </DialogTitle>
        <DialogContent variant="modal">
          {this.state.isLoading ? this.renderLoading() : this.renderForm()}
        </DialogContent>
        {!this.state.isLoading && (
          <DialogActions
            variant="modal"
            sx={{ flexWrap: "wrap", gap: 1, justifyContent: "end" }}
          >
            <Button
              variant="outlined"
              color="error"
              onClick={() => this.didClickClose()}
            >
              Cancelar
            </Button>

            <Button
              variant="contained"
              color="error"
              onClick={() => this.didClickDelete()}
            >
              Arquivar Aplicação
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}

export default ArchiveApplicationModal;
